const getShortsId = link => {
	const lastSlashIndex = link.lastIndexOf('/');
	return link.slice(lastSlashIndex + 1);
};

export default getShortsId;
